import useEvent from '@lyearn/core/hooks/useEvent';
import { Trans, useTranslation } from '@lyearn/i18n';
import { Typography, useSnackbar } from '@lyearn/ui';
import useResponse from '@/hooks/useResponse';

import { useMoveFileMutation } from '../graphql/mutations/generated/moveCategory';
import { CategoryType } from '../types';

export default function useMoveCategory(onSuccess?: () => void) {
  const { t } = useTranslation();
  const [{ fetching }, executeMoveFile] = useMoveFileMutation();
  const { handleResponse } = useResponse();
  const { showSnackbar } = useSnackbar();

  const onMerge = useEvent(
    async ({
      category,
      newParentCategory,
      rootCategory,
      orderInNewParent,
    }: {
      category: CategoryType;
      newParentCategory?: CategoryType;
      rootCategory: CategoryType;
      orderInNewParent: number;
    }) => {
      const result = await executeMoveFile({
        data: {
          fileIdToMove: category.id,
          newParentId: newParentCategory?.id,
          orderInNewParent: orderInNewParent,
        },
      });

      handleResponse({
        condition: Boolean(
          result.data?.moveFile?.newParent?.id === (newParentCategory?.id || rootCategory.id),
        ),
        onSuccess: () => {
          showSnackbar({
            message: (
              <Trans
                components={{ label: <Typography variant="label-02" /> }}
                i18nKey={
                  newParentCategory?.name
                    ? 'Discover:Category.Admin.CategoryHasBeenMovedIntoParentCategory'
                    : 'Discover:Category.Admin.CategoryHasBeenMovedIntoRootCategory'
                }
                values={{
                  name: category.name,
                  parentName: newParentCategory?.name,
                }}
              />
            ),
          });
          onSuccess?.();
        },
      });
    },
  );

  return {
    fetching,
    onMerge,
  };
}
